import { render } from "./TripForm.vue?vue&type=template&id=5899fecf&scoped=true"
import script from "./TripForm.vue?vue&type=script&lang=js"
export * from "./TripForm.vue?vue&type=script&lang=js"

import "./mobileForm.css?vue&type=style&index=0&id=5899fecf&scoped=true&lang=css"
import "./TripForm.vue?vue&type=style&index=1&id=5899fecf&scoped=true&lang=css"

import exportComponent from "/app/src/client/.yarn/__virtual__/vue-loader-virtual-e12e5a5897/0/cache/vue-loader-npm-17.0.1-f552b82805-b10a7b05ba.zip/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5899fecf"]])

export default __exports__